import { render, staticRenderFns } from "./RouterViewWithTransition.vue?vue&type=template&id=bea0ed4e&"
import script from "./RouterViewWithTransition.vue?vue&type=script&lang=ts&"
export * from "./RouterViewWithTransition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports